import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import './text_field.css';

var TextField = function (_Component) {
	_inherits(TextField, _Component);

	function TextField(props) {
		_classCallCheck(this, TextField);

		var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

		_this.state = {
			value: props.initialValue || ''
		};

		_this.handleChange = _this.handleChange.bind(_this);
		return _this;
	}

	_createClass(TextField, [{
		key: 'handleChange',
		value: function handleChange(event) {
			this.setState({ value: event.target.value });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    title = _props.title,
			    note = _props.note,
			    required = _props.required,
			    itemAction = _props.itemAction,
			    maxlength = _props.maxlength,
			    fieldType = _props.fieldType,
			    min = _props.min;


			var style = void 0;
			if (maxlength) {
				var width = Number(maxlength) * 11;
				style = { width: width + 'px' };
			}
			return React.createElement(
				'div',
				{ className: 'TextField' },
				React.createElement(
					'label',
					null,
					React.createElement(
						'p',
						{ className: 'full' },
						title
					),
					React.createElement('input', {
						type: fieldType ? fieldType : "text",
						value: this.state.value,
						maxLength: maxlength,
						style: style,
						onChange: function onChange(e) {
							_this2.handleChange(e);itemAction(e.currentTarget.value, title);
						},
						min: min
					}),
					React.createElement(
						'p',
						{ className: 'note' },
						note
					)
				)
			);
		}
	}]);

	return TextField;
}(Component);

export default TextField;